import { ChevronRightIcon } from 'lucide-react'

import { StandardLynkIcon } from 'src/features/lynk/icons/standard-lynk-icon'

import type { SearchHistoryItem } from '../api/use-search-history'

interface TextSearchResultItemProps {
  item: SearchHistoryItem
  onClick?: (rawQuery: string) => void
}

const TextSearchResultItem = ({ item, onClick }: TextSearchResultItemProps) => {
  const { rawQuery } = item
  const queryText = rawQuery ?? ''

  return (
    <button
      type="button"
      onClick={() => onClick?.(queryText)}
      className="group flex w-full cursor-pointer flex-row justify-between gap-4 text-left"
    >
      <div className="flex items-center gap-2">
        <StandardLynkIcon width={16} height={16} className="mt-1" />
        <p className="text-sm text-primary group-hover:underline">{queryText}</p>
      </div>
      <span className="text-[13px] text-muted">
        <ChevronRightIcon size={16} />
      </span>
    </button>
  )
}

export default TextSearchResultItem
